<div class="ui-payments">
    <div class="ui-payments-header" *ngIf="paymentsInitStatus">
        <div class="ui-payments-header-container">
            <div class="ui-payments-header-title">
                <h1>Listado de pagos</h1>
            </div>
        </div>
    </div>

    <div class="ui-payments-list" *ngIf="paymentsInitStatus">
        <div class="ui-payments-list-container">
            <div class="ui-bar-filters">
                <div class="el-left-filters">
                    <!--<button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterStatus">Estado<i *ngIf="filters.status != ''">: {{filters.status}}</i> <mat-icon>expand_more</mat-icon></button>

                    <mat-menu #filterStatus="matMenu">
                        <button mat-menu-item (click)="onFilterSelect('status', '')">Todos</button>
                        <button mat-menu-item (click)="onFilterSelect('status', 'Ingresado')">Ingresado</button>
                        <button mat-menu-item (click)="onFilterSelect('status', 'Confirmado')">Confirmado</button>
                        <button mat-menu-item (click)="onFilterSelect('status', 'Aplicado')">Aplicado</button>
                    </mat-menu>-->
                    
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterPaymentMethod">Medio de pago<i *ngIf="filters.paymentMethod != ''">: {{filters.paymentMethod}}</i> <mat-icon>expand_more</mat-icon></button>

                    <mat-menu #filterPaymentMethod="matMenu">
                        <button mat-menu-item (click)="onFilterSelect('paymentMethod', '')">Todo</button>
                        <button mat-menu-item (click)="onFilterSelect('paymentMethod', item.name)" *ngFor="let item of filterPaymentMethods; last as last">{{item.name}}</button>
                    </mat-menu>
                    
                    <mat-form-field class="date-multiple" >
                        <mat-label>Fecha de emisión</mat-label>
                        <mat-date-range-input [rangePicker]="filterDate" >
                            <input matStartDate placeholder="Desde" (focus)="filterDate.open()" [(ngModel)]="filters.date.start">
                            <input matEndDate placeholder="Hasta" (focus)="filterDate.open()" [(ngModel)]="filters.date.end" (dateChange)="onFilterSelect('date')">
                        </mat-date-range-input>
                        <button matSuffix mat-flat-button (click)="onFilterSelect('date', '')" *ngIf="filters.date.end != '' && filters.date.end != null"><mat-icon>close</mat-icon></button>
                        <mat-date-range-picker #filterDate></mat-date-range-picker>
                    </mat-form-field>
                    
                    <mat-form-field class="date-multiple">
                        <mat-label>Fecha de pago</mat-label>
                        <mat-date-range-input [rangePicker]="filterDatePayment">
                            <input matStartDate placeholder="Desde" (focus)="filterDatePayment.open()" [(ngModel)]="filters.datePayment.start">
                            <input matEndDate placeholder="Hasta" (focus)="filterDatePayment.open()" [(ngModel)]="filters.datePayment.end" (dateChange)="onFilterSelect('datePayment')">
                        </mat-date-range-input>
                        <button matSuffix mat-flat-button (click)="onFilterSelect('datePayment', '')" *ngIf="filters.datePayment.end != '' && filters.datePayment.end != null"><mat-icon>close</mat-icon></button>
                        <mat-date-range-picker #filterDatePayment></mat-date-range-picker>
                    </mat-form-field>
                </div>

                <div class="el-right-filters">
                    <button mat-flat-button class="ui-button" [matMenuTriggerFor]="filterExport">Exportar listado <mat-icon>expand_more</mat-icon></button>
    
                    <mat-menu #filterExport="matMenu">
                        <button mat-menu-item (click)="onExport('xls')">Microsoft Excel (xlsx)</button>
                        <button mat-menu-item (click)="onExport('cvs')">CVS separado por coma (cvs)</button>
                        <button mat-menu-item (click)="onExport('json')">Archivo JSON (json)</button>
                    </mat-menu>
                </div>
            </div>
            
            <div class="ui-shadow" style="position:relative;">
                <div class="ui-spinner-container" *ngIf="paymentsUpdating">
                    <mat-spinner class="ui-spinner" [diameter]="25"></mat-spinner>
                </div>

                <div class="payment" *ngIf="payments.length <= 0"><div class="payment-empty">No existen pagos para mostrar</div></div>

                <div class="payment" *ngFor="let payment of payments; last as last">
                    <div class="payment-data" (click)="onViewDetails(payment)">
                        <span class="payment-recipt">{{payment.recipt}}</span>
                        <span class="payment-date">{{payment.date | date: 'dd/MM/yyyy'}}</span>
                    </div>
                    <div class="payment-amount" (click)="onViewDetails(payment)">
                        <small>$</small> {{payment.amount}}
                    </div>
                </div>

                <mat-paginator *ngIf="payments.length > 0" [length]="paymentsTotal" [pageSize]="paymentsPageSize" [pageSizeOptions]="[10, 20, 50, 100]" (page)="onPaginationChange($event)"></mat-paginator>
            </div>
        </div>
    </div>

    <ui-screen-loader *ngIf="!paymentsInitStatus"></ui-screen-loader>
</div>